import { Wifi, WifiOff, RefreshCw, AlertTriangle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { fmtDate } from "@/lib/format";

export function SyncPill() {
  const { online, syncing, syncError, queue, failed, syncNow, t, base, offlineSince, lang } = useApp();
  const nav = useNavigate();
  const pending = queue.length;
  const fmt = (d) => fmtDate(d, lang);
  const title = [
    `${t("last_sync")}: ${base.lastSync ? fmt(base.lastSync) : "—"}`,
    offlineSince ? t("offline_days", { t: fmt(offlineSince) }) : null,
    pending ? `${t("oldest_pending")}: ${fmt(queue[0].ts)}` : null,
  ].filter(Boolean).join("\n");
  let cls = "bg-[#1F9D55] text-white border-[#1F9D55]";
  let Icon = Wifi;
  let label = t("synced");
  if (!online) { cls = "bg-[#E67E22] text-white border-[#E67E22]"; Icon = WifiOff; label = t("offline"); }
  else if (syncing) { cls = "bg-white text-foreground border-border"; Icon = RefreshCw; label = t("syncing"); }
  else if (syncError) { cls = "bg-[#E74C3C] text-white border-[#E74C3C]"; Icon = AlertTriangle; label = t("sync_error"); }
  else if (pending) { cls = "bg-[#F39C12] text-white border-[#F39C12]"; Icon = RefreshCw; label = t("pending"); }
  return (
    <button
      type="button"
      onClick={syncNow}
      title={title}
      data-testid="sync-status-indicator"
      data-state={!online ? "offline" : syncing ? "syncing" : syncError ? "error" : pending ? "pending" : "synced"}
      className={`flex items-center gap-1.5 px-3 h-10 rounded-full text-xs font-bold border shadow-sm transition-colors ${cls}`}
    >
      <Icon className={`w-4 h-4 ${syncing ? "animate-spin" : ""}`} />
      <span className="hidden sm:inline">{label}</span>
      {pending > 0 && <span data-testid="sync-pending-count" className="min-w-5 h-5 px-1 rounded-full bg-white/25 grid place-items-center">{pending}</span>}
      {failed.length > 0 && <span onClick={(e) => { e.stopPropagation(); nav("/team?tab=sync"); }} title={t("failed_ops")} data-testid="sync-failed-count" className="min-w-5 h-5 px-1 rounded-full bg-[#E74C3C] text-white grid place-items-center">!{failed.length}</span>}
    </button>
  );
}
